import React from "react";
import { Link, LongTextLabel } from "@sscs/ui";
import { InventoryIcon as PackageIcon, ProjectIcon } from "@sscs/ui/icons";
import { useProjectsRoute } from "Hooks";
import styles from "./portalPurlLink.module.scss";

type PortalPurlLinkProps = {
  projectId: string;
  packageId: string;
  projectName: string;
  packageName: string;
  version?: string;
  className?: string;
};

const PortalPurlLink = ({
  projectId,
  packageId,
  projectName,
  packageName,
  version,
  className,
}: PortalPurlLinkProps): React.JSX.Element => {
  const projectsRoute = useProjectsRoute(projectId);

  return (
    <div className={`${styles.purl} ${className}`}>
      <span>pkg:rl /</span>
      <Link
        to={projectsRoute}
        fullWidth={false}
        underline="always"
        title={projectName}
        inline
      >
        <ProjectIcon size="inherit" />
        &nbsp;
        <span>{projectName}</span>
      </Link>
      <span>&nbsp;/&nbsp;</span>
      <Link
        to={`${projectsRoute}/package/${packageId}`}
        fullWidth={false}
        underline="always"
        title={packageName}
        inline
      >
        <PackageIcon size="inherit" />
        &nbsp;
        <span>{packageName}</span>
      </Link>
      {version && (
        <LongTextLabel label={`@${version}`} className={styles.version} />
      )}
    </div>
  );
};

export default PortalPurlLink;
